/// <reference path="../globals.d.ts" />

/// <reference path="../globals.d.ts" />

const $j =
    typeof window !== 'undefined' && (window as Window & { jQuery?: { noConflict: () => unknown } }).jQuery
        ? (window as Window & { jQuery: { noConflict: () => unknown } }).jQuery.noConflict()
        : (() => {}) as { (s: string): unknown };

(window as Window & Record<string, unknown>).$j = $j;
(window as Window & Record<string, unknown>).resizerfn = null;
(window as Window & Record<string, unknown>).scrollerfn = null;
(window as Window & Record<string, unknown>)._rps = 100;
(window as Window & Record<string, unknown>)._sps = 100;
(window as Window & Record<string, unknown>).scrolledtop = 250;
(window as Window & Record<string, unknown>).loader_delay = 200;
(window as Window & Record<string, unknown>).loader_fadeout = 300;
(window as Window & Record<string, unknown>).msizer = $j('#msizer');
(window as Window & Record<string, unknown>).body = $j('body');
